"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    container: {
      padding: spacing(2),
      height: 'calc(100vh - 129px)'
    }
  };
});

var FlowWrapper = function FlowWrapper(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, (0, _extends2.default)({
    classes: {
      container: classes.container
    }
  }, props));
};

var _default = FlowWrapper;
exports.default = _default;